import { createSignal } from "solid-js";

import { registerSW } from "virtual:pwa-register";

const [pendingUpdate, setPendingUpdate] = createSignal<() => void>();

export { pendingUpdate };

const updateSW = registerSW({
  onNeedRefresh() {
    setPendingUpdate(() => () => {
      void updateSW(true);
      // Konkord: it reloads once the new version takes over; on a first visit
      // there is nothing to take over, and the button would do nothing
      if (!navigator.serviceWorker.controller) {
        setTimeout(() => location.reload(), 3000);
      }
    });
  },
  onOfflineReady() {
    console.info("Ready to work offline =)");
    // toast to users
  },
  onRegistered(r) {
    // Konkord: check for updates every minute; one found waits, see ForceUpdate
    setInterval(() => r!.update(), 60_000);
  },
});
